import React from 'react';


import './radioButtons.css';





export function TypeDropdown({ radioValue, onChange }) {
    return (
        <div className="dropdown" id='dropdown' >
            <label className="dropdown-label" id="dropdown-label" htmlFor="dropdown-select">Property Type:</label>
            <select value={radioValue} onChange={onChange} className="dropdown-select" id='dropdown-select'>
                <option value="All">All</option>
                <option value="Flat">Flat</option>
                <option value="Terraced">Terraced</option>
                <option value="Semi-detached">Semi-Detached</option>
                <option value="Detached">Detached</option>
            </select>
        </div>
    );
}

